var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 860,
    height: 860,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.60881012 0.30415833 1.21762024 0.60831665 1.84487915 0.92169189 C8.6095005 4.31740093 15.28338055 7.86597153 21.87890625 11.578125 C22.78660011 12.08324615 22.78660011 12.08324615 23.71263123 12.59857178 C27.94408606 15.01317212 27.94408606 15.01317212 29.0625 17.25 C31.68866876 18.42486497 34.33294585 19.34014862 37.0625 20.25 C38.0625 21.25 39.0625 22.25 40.0625 23.25 C41.0525 23.58 42.0425 23.91 43.0625 24.25 C42.7325 24.91 42.4025 25.57 42.0625 26.25 C43.3825 25.92 44.7025 25.59 46.0625 25.25 C45.7325 26.24 45.4025 27.23 45.0625 28.25 C46.17625 28.3325 47.29 28.415 48.4375 28.5 C49.63375 28.7475 50.83 28.995 52.0625 29.25 C53.1875 31.1875 53.1875 31.1875 54.0625 33.25 C55.7260479 33.92441131 57.39316942 34.5900321 59.0625 35.25 C60.7458878 36.89977607 62.41049525 38.56879928 64.0625 40.25 C65.75049351 41.69084181 67.45955189 43.1073254 69.1875 44.5 C70.15171875 45.28246094 71.1159375 46.06492187 72.109375 46.87109375 C73.99196777 48.38762681 75.8771211 49.90099056 77.765625 51.41015625 C84.06137737 56.48173455 90.02689562 61.81981056 95.9296875 67.3359375 C98.6657313 69.8921318 101.44893419 72.39004193 104.25 74.875 C111.35427016 81.25269707 118.09694043 87.95143146 124.30078125 95.2109375 C126.25855739 97.4769223 128.28478948 99.67143494 130.3125 101.875 C135.41193853 107.52853712 140.07079093 113.4871607 144.71582031 119.51367188 C145.9608024 121.11887721 147.22565465 122.70861837 148.4921875 124.296875 C214.65670181 208.03294884 238.03804245 309.54996836 233.03515625 440.96875 C220.83995779 535.90717194 176.68491243 620.57290067 98.25 701.625 C95.20666912 704.24694661 92.21897726 706.91909667 89.25 709.625 C81.74258363 716.39549207 73.86739076 722.69942352 65.83984375 728.83984375 C63.96059179 730.27561536 63.96059179 730.27561536 62.0625 732.25 C60.0795177 734.2329823 58.55031693 735.04378573 56.0625 736.25 C52.81400023 737.97226496 52.81400023 737.97226496 52.0625 741.25 C49.7525 741.58 47.4425 741.91 45.0625 742.25 C45.3925 743.24 45.7225 744.23 46.0625 745.25 C45.0725 745.58 44.0825 745.91 43.0625 746.25 C40.75405058 747.3272764 38.65531789 748.50821305 36.5 749.875 C34.0625 751.25 34.0625 751.25 31.0625 751.25 C31.0625 751.91 31.0625 752.57 31.0625 753.25 C-13.11097838 778.91734307 -58.86407548 797.95391315 -108.9375 808.25 C-109.92121582 808.45705566 -110.90493164 808.66411133 -111.91845703 808.87744141 C-118.560966 810.25035768 -125.21577322 811.34384117 -131.9375 812.25 C-133.60063232 812.47429687 -133.60063232 812.47429687 -135.29736328 812.703125 C-227.14774675 824.32373248 -317.67415884 807.74172439 -399.62280273 765.38232422 C-402.00350366 764.15421144 -402.00350366 764.15421144 -404.9375 763.25 C-404.9375 762.59 -404.9375 761.93 -404.9375 761.25 C-405.72125 761.04375 -406.505 760.8375 -407.3125 760.625 C-419.57579787 755.97340426 -419.57579787 755.97340426 -421.9375 751.25 C-423.60250443 750.90846063 -425.26928677 750.57550502 -426.9375 750.25 C-427.5975 749.59 -428.2575 748.93 -428.9375 748.25 C-432.18320741 745.96470072 -432.18320741 745.96470072 -435.9375 745.25 C-436.14375 744.651875 -436.35 744.05375 -436.5625 743.4375 C-438.45629122 740.42465033 -440.72822973 739.65405574 -443.9375 738.25 C-444.5975 737.92 -445.2575 737.59 -445.9375 737.25 C-445.6075 736.59 -445.2775 735.93 -444.9375 735.25 C-445.93910156 734.94255859 -445.93910156 734.94255859 -446.9609375 734.62890625 C-451.02869071 732.74450089 -454.14107095 730.0538611 -457.5625 727.1875 C-458.27180664 726.6011377 -458.98111328 726.01477539 -459.71191406 725.41064453 C-461.13626005 724.23315506 -462.5588218 723.0535036 -463.97949219 721.87158203 C-466.52685668 719.76190685 -469.10882249 717.69621182 -471.6875 715.625 C-477.11562946 711.17863984 -482.2650907 706.45207272 -487.39941406 701.67480469 C-488.96435077 700.22512681 -490.53896073 698.78675341 -492.1171875 697.3515625 C-499.44616909 690.68606811 -506.53771979 683.97841931 -513.00390625 676.4609375 C-515.18345981 673.9687611 -517.4352328 671.55161332 -519.6875 669.125 C-524.98430626 663.31456404 -529.81863348 657.20230889 -534.60693359 650.97021484 C-535.84407136 649.37078866 -537.10284315 647.78816052 -538.36328125 646.20703125 C-549.77249031 631.77279459 -559.76950149 616.1898156 -568.9375 600.25 C-569.31261719 599.60659668 -569.68773437 598.96319336 -570.07421875 598.30029297 C-593.95817515 557.20758892 -609.43525255 512.68237948 -618.9375 466.25 C-619.11506836 465.4053418 -619.29263672 464.56068359 -619.47558594 463.69042969 C-620.53393757 458.56709739 -621.29670368 453.44112671 -621.9375 448.25 C-622.07140137 447.22084473 -622.20530273 446.19168945 -622.34326172 445.13134766 C-634.75127625 345.46247052 -615.42475751 243.66338105 -534.91748047 119.98999023 C-520.91461129 102.00828778 -505.4926191 83.69432284 -488.125 68.875 C-485.08166912 66.25305339 -482.09397726 63.58090333 -479.125 60.875 C-471.61758363 54.10450793 -463.74239076 47.80057648 -455.71484375 41.66015625 C-453.83559179 40.22438464 -453.83559179 40.22438464 -451.9375 38.25 C-450.390625 37.26 -450.390625 37.26 -448.8125 36.25 C-447.86375 35.59 -446.915 34.93 -445.9375 34.25 C-445.9375 33.59 -445.9375 32.93 -445.9375 32.25 C-445.15375 32.1675 -444.37 32.085 -443.5625 32 C-440.79000896 31.52193661 -440.79000896 31.52193661 -439.625 29.1875 C-439.2846875 28.2284375 -439.2846875 28.2284375 -438.9375 27.25 C-438.2775 27.25 -437.6175 27.25 -436.9375 27.25 C-436.6075 26.59 -436.2775 25.93 -435.9375 25.25 C-435.2775 25.25 -434.6175 25.25 -433.9375 25.25 C-433.6075 24.59 -433.2775 23.93 -432.9375 23.25 C-431.27249557 22.90846063 -429.60571323 22.57550502 -427.9375 22.25 C-427.2775 21.59 -426.6175 20.93 -425.9375 20.25 C-425.256875 20.085 -424.57625 19.92 -423.875 19.75 C-423.235625 19.585 -422.59625 19.42 -421.9375 19.25 C-421.6075 18.59 -421.2775 17.93 -420.9375 17.25 C-378.89833136 -9.98467736 -329.66347869 -27.55572967 -280.9375 -37.75 C-279.94508301 -37.95995605 -278.95266602 -38.16991211 -277.93017578 -38.38623047 C-271.29688787 -39.75636228 -264.64967706 -40.84512857 -257.9375 -41.75 C-256.82874512 -41.89953125 -255.71999023 -42.0490625 -254.57763672 -42.203125 C-167.17006674 -53.26164237 -78.78050296 -39.39460681 0 0 Z ",
    fill: "#4EA4F6",
    transform: "translate(624.9375,44.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.73680739 2.832299 5.62225174 5.56815725 7.28515625 9.8984375 C7.69480683 13.57266523 7.66305154 17.20540341 7.59765625 20.8984375 C7.5829126 22.43939087 7.5829126 22.43939087 7.56787109 24.01147461 C7.43651766 31.80981771 6.65828885 39.21836479 5.28515625 46.8984375 C4.96538383 49.14741546 4.65309005 51.39746739 4.34765625 53.6484375 C3.49181339 59.66608262 2.4897704 65.65100383 1.46337891 71.64111328 C0.25293486 78.83239629 -0.71525962 86.05204446 -1.62475586 93.28710938 C-2.14288731 97.27918532 -2.71978036 101.16011638 -3.75 105.0546875 C-4.73093773 108.96255278 -5.22319057 112.77603487 -5.58984375 116.7734375 C-6.763148 128.17430083 -8.57544365 139.46298738 -10.37762451 150.77868652 C-10.73738177 153.04011089 -11.09565278 155.30176711 -11.45361328 157.56347656 C-14.18044949 174.79058415 -16.9272001 192.01447946 -19.69921875 209.234375 C-20.37151359 213.41399509 -21.04331966 217.59369351 -21.71484375 221.7734375 C-21.88087097 222.80629883 -22.04689819 223.83916016 -22.21795654 224.90332031 C-25.06846009 242.6554902 -27.80350235 260.42387653 -30.45703125 278.20654297 C-30.59448761 279.12180756 -30.73194397 280.03707214 -30.87356567 280.98007202 C-31.1261932 282.66256158 -31.37693846 284.34533558 -31.62521362 286.0284729 C-32.36610011 290.95166325 -33.26918633 295.82184623 -34.28352356 300.69619751 C-34.87321678 303.7070605 -35.20681769 306.72315652 -35.52734375 309.7734375 C-36.56459598 318.90883833 -38.27331559 327.92649452 -39.95043945 336.96240234 C-40.87937721 342.00863197 -41.78151819 347.01483888 -42.3046875 352.12109375 C-42.71484375 355.8984375 -42.71484375 355.8984375 -43.71484375 357.8984375 C-43.93268842 360.14753654 -44.13905641 362.39775155 -44.33984375 364.6484375 C-45.64213884 375.87291613 -50.3583277 385.4075135 -58.52734375 393.34765625 C-66.25370781 398.82509648 -74.65198492 398.75033312 -83.71484375 397.8984375 C-87.80761904 397.14802348 -91.75097883 396.15966725 -95.71484375 394.8984375 C-95.71484375 394.2384375 -95.71484375 393.5784375 -95.71484375 392.8984375 C-96.545 392.80949219 -97.37515625 392.72054688 -98.23046875 392.62890625 C-102.39821009 391.75517572 -105.70787062 390.16220924 -109.46484375 388.2109375 C-110.1707666 387.85008057 -110.87668945 387.48922363 -111.60400391 387.11743164 C-119.65579268 382.96074865 -127.19061793 378.32326045 -134.5703125 373.0703125 C-138.79171212 370.15466258 -143.09511482 367.37268405 -147.40234375 364.5859375 C-155.24202698 359.51167146 -163.03855386 354.38066817 -170.79589844 349.18164062 C-172.85190835 347.80678209 -174.91187015 346.43800081 -176.97265625 345.0703125 C-187.18699053 338.28763614 -197.33079468 331.40789449 -207.43505859 324.46240234 C-209.63552868 322.95284876 -211.84040364 321.44998273 -214.046875 319.94921875 C-221.10571706 315.13968824 -228.06068903 310.2490365 -234.85546875 305.0703125 C-236.7882455 303.6022471 -238.7367752 302.15472822 -240.69921875 300.7265625 C-264.86694694 283.07034657 -264.86694694 283.07034657 -267.140625 270.5546875 C-267.55112499 263.70520197 -264.72197614 258.83745278 -260.96484375 253.3359375 C-258.40793671 250.56595488 -255.65325596 248.16469709 -252.7890625 245.71875 C-250.84480401 244.01248925 -249.02460689 242.24547265 -247.21484375 240.3984375 C-244.88762702 238.02606269 -242.49545662 235.79616262 -239.9765625 233.62890625 C-235.90027038 230.08450798 -231.95261129 226.42102117 -228.02734375 222.7109375 C-222.95141665 217.92936185 -217.85436594 213.1740697 -212.71484375 208.4609375 C-208.54378692 204.63253469 -204.49361281 200.71198858 -200.5234375 196.67578125 C-198.73103216 194.9143462 -196.87667191 193.27876949 -194.96484375 191.6484375 C-190.64002499 187.95252665 -186.69249427 183.90613236 -182.75097656 179.80957031 C-181.44173042 178.46957866 -180.08196694 177.17932676 -178.71484375 175.8984375 C-178.05484375 175.8984375 -177.39484375 175.8984375 -176.71484375 175.8984375 C-176.328125 175.00511719 -176.328125 175.00511719 -175.93359375 174.09375 C-174.60672981 171.7036938 -173.32375032 170.49340638 -171.21484375 168.7734375 C-166.08798008 164.43318649 -161.42604898 159.68102463 -156.71484375 154.8984375 C-151.50289392 149.60751873 -146.28542271 144.43064393 -140.64892578 139.59228516 C-129.09127846 129.47022544 -115.42186127 117.43520209 -111.71484375 101.8984375 C-112.04680503 99.67823627 -112.04680503 99.67823627 -112.71484375 97.8984375 C-128.30497298 96.89262271 -141.60723077 106.92855602 -154.02734375 115.3359375 C-155.57615234 116.37657349 -155.57615234 116.37657349 -157.15625 117.43823242 C-160.3467933 119.58528325 -163.531829 121.74024396 -166.71484375 123.8984375 C-167.70145996 124.56713867 -168.68807617 125.23583984 -169.70458984 125.92480469 C-177.94220964 131.51466771 -186.15980329 137.13348107 -194.35546875 142.78466797 C-212.70539741 155.43514868 -231.17676307 167.9137425 -249.7434082 180.24365234 C-257.34338339 185.29866169 -264.91027196 190.40147036 -272.47203064 195.51341248 C-282.54378661 202.32208087 -292.62496258 209.11665821 -302.71484375 215.8984375 C-303.49533081 216.42332764 -304.27581787 216.94821777 -305.07995605 217.48901367 C-309.1976999 220.25650552 -313.32177739 223.01394532 -317.4581604 225.75350952 C-318.64937699 226.54414354 -319.83857094 227.33783551 -321.02548218 228.13491821 C-338.72487633 240.00966621 -355.98832295 243.32679508 -377.0677948 239.337677 C-385.73384482 237.60518638 -394.11084084 234.93544986 -402.52734375 232.2734375 C-404.24969267 231.73562077 -405.97218819 231.19827333 -407.69482422 230.66137695 C-419.74590715 226.89212448 -431.7527004 222.99587409 -443.703125 218.91796875 C-447.72252125 217.54959455 -451.75548574 216.2618664 -455.8203125 215.03515625 C-456.78565918 214.73649658 -457.75100586 214.43783691 -458.74560547 214.13012695 C-460.52407283 213.58241395 -462.30797175 213.05185183 -464.09814453 212.54370117 C-470.78104783 210.45213158 -474.45058784 206.97065627 -477.83911133 200.87646484 C-479.30361553 197.56857161 -479.2455622 195.49552924 -478.71484375 191.8984375 C-471.87538968 178.50852038 -455.65718331 173.30802014 -442.55908203 168.04833984 C-439.53850655 166.82714581 -436.53023697 165.57893756 -433.5234375 164.32421875 C-416.80852617 157.35329541 -400.02680985 150.54989975 -383.23217773 143.77368164 C-372.15295745 139.30234904 -361.09799948 134.79004443 -350.125 130.0625 C-342.33769591 126.71700157 -334.49884361 123.50196404 -326.65338135 120.29568481 C-322.32512577 118.5266 -317.99858368 116.75333272 -313.671875 114.98046875 C-312.38008331 114.45129097 -312.38008331 114.45129097 -311.06219482 113.91142273 C-299.62845497 109.22625838 -288.21306713 104.49692012 -276.79943848 99.76300049 C-273.6749016 98.4671328 -270.55020956 97.17163938 -267.42553711 95.87609863 C-263.02194273 94.05028376 -258.61839672 92.22435224 -254.21484375 90.3984375 C-248.96779366 88.22277023 -243.7207373 86.04711812 -238.47363281 83.87158203 C-235.54322383 82.65658253 -232.61287838 81.44143012 -229.68261719 80.22607422 C-218.04953344 75.40195751 -206.41158199 70.59033066 -194.7578125 65.81640625 C-193.89162292 65.46148605 -193.02543335 65.10656586 -192.13299561 64.7408905 C-187.86783597 62.99345665 -183.60213408 61.24736854 -179.33544922 59.50366211 C-171.35377332 56.23828984 -163.3952648 52.93045984 -155.47583008 49.51611328 C-132.19380217 39.48211065 -108.79861495 29.69863041 -85.33984375 20.0859375 C-84.54957794 19.76200012 -83.75931213 19.43806274 -82.94509888 19.10430908 C-75.87685005 16.20910069 -68.80448586 13.32622031 -61.70545959 10.50721741 C-54.1613401 7.51096583 -46.71879161 4.33208861 -39.32617188 0.98046875 C-27.09980199 -4.39355543 -11.93263849 -7.6651573 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(627.71484375,255.1015625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-1.10683746 5.65245007 -3.83667189 7.07771554 -9.125 8.75 C-10.36507812 9.15734375 -11.60515625 9.5646875 -12.8828125 9.984375 C-21.0536657 12.22125115 -29.58594572 12.18153259 -38 12.1875 C-38.93972656 12.19974609 -39.87945312 12.21199219 -40.84765625 12.22460938 C-41.74355469 12.22654297 -42.63945312 12.22847656 -43.5625 12.23046875 C-44.77099609 12.23663208 -44.77099609 12.23663208 -46.00390625 12.24291992 C-48 12 -48 12 -50 10 C-49.41734375 10.01571045 -48.8346875 10.0314209 -48.234375 10.04760742 C-31.40891309 10.43947402 -15.51722356 10.75604159 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#5FA5E5",
    transform: "translate(302,485)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-0.9075 3.268125 -1.815 3.53625 -2.75 3.8125 C-5.94538598 4.79976373 -5.94538598 4.79976373 -8.0625 6.5625 C-10.38916533 8.28873556 -12.1718193 8.46129891 -15 9 C-15.969375 9.495 -16.93875 9.99 -17.9375 10.5 C-21 12 -21 12 -24.0625 12.5 C-27.0632493 12.81923808 -27.0632493 12.81923808 -29.5 14.5625 C-32.52962925 16.30453682 -34.56159089 16.23988901 -38 16 C-34.82207691 13.88138461 -31.57160817 12.4568276 -28.06640625 10.99609375 C-27.39206039 10.71274673 -26.71771454 10.42939972 -26.02293396 10.13746643 C-24.59886181 9.54005306 -23.17412686 8.9442175 -21.7487793 8.34985352 C-19.57213557 7.44152101 -17.39826032 6.5267956 -15.22460938 5.61132812 C-13.83870328 5.03086398 -12.45264067 4.45077336 -11.06640625 3.87109375 C-10.4183754 3.59817001 -9.77034454 3.32524628 -9.10267639 3.04405212 C-6.10288719 1.79758854 -3.18773297 0.65572511 0 0 Z ",
    fill: "#DCF4FB",
    transform: "translate(571,264)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.3394908 1.3557994 16.14647052 3.89145671 24.125 6.625 C25.36765625 7.04523438 26.6103125 7.46546875 27.890625 7.8984375 C30.92899334 8.92680832 33.96533385 9.96076577 37 11 C32.63496852 12.18719263 29.46726786 11.67009018 25 11 C24.67 10.01 24.34 9.02 24 8 C23.27296875 8.03738281 22.5459375 8.07476562 21.796875 8.11328125 C18.82284218 7.99282461 16.962868 7.37105516 14.25 6.1875 C9.56639875 4.21138596 4.8414366 2.54364645 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#63A6E2",
    transform: "translate(180,473)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C2.19983784 2.25756045 -0.42034072 3.73487682 -3.765625 5.04296875 C-4.65507812 5.39423828 -5.54453125 5.74550781 -6.4609375 6.10742188 C-7.38132812 6.46384766 -8.30171875 6.82027344 -9.25 7.1875 C-10.18585938 7.55552734 -11.12171875 7.92355469 -12.0859375 8.30273438 C-14.38853516 9.20732631 -16.6931989 10.10619401 -19 11 C-19.66 10.34 -20.32 9.68 -21 9 C-20.37351562 8.73445313 -19.74703125 8.46890625 -19.1015625 8.1953125 C-18.28429687 7.84210938 -17.46703125 7.48890625 -16.625 7.125 C-15.40683594 6.60292969 -15.40683594 6.60292969 -14.1640625 6.0703125 C-11.86197701 5.07553933 -11.86197701 5.07553933 -10 3 C-7.375 3.375 -7.375 3.375 -5 4 C-5 3.34 -5 2.68 -5 2 C-3.35 2 -1.7 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#59A4E5",
    transform: "translate(437,317)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.505 1.515625 1.01 2.03125 0.5 2.5625 C-1.60362659 5.98089322 -1.46357591 8.0264922 -1 12 C0.12983238 14.79278912 1.48593943 17.39770839 3 20 C0.625 19.8125 0.625 19.8125 -2 19 C-4.93301309 14.39097944 -4.37650918 8.86146978 -3.6875 3.625 C-3 2 -3 2 0 0 Z ",
    fill: "#62A8E7",
    transform: "translate(151,442)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.20936103 5.86210878 0.84216942 11.55513315 0.1875 17.375 C0.11740723 18.07689453 0.04731445 18.77878906 -0.02490234 19.50195312 C-0.3875261 22.49848479 -0.66691183 24.58178012 -2.57421875 26.9765625 C-3.04472656 27.31429688 -3.51523437 27.65203125 -4 28 C-2.88156738 18.62420318 -1.65562772 9.29969612 0 0 Z ",
    fill: "#63A6E7",
    transform: "translate(618,396)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.21659761 3.3041126 -2.4503173 5.5908834 -4.6875 7.875 C-5.62625977 8.85146484 -5.62625977 8.85146484 -6.58398438 9.84765625 C-9.8281834 13.14281128 -12.40544013 15.75252868 -17 17 C-16.06409496 15.8944811 -15.12620142 14.79064547 -14.1875 13.6875 C-13.66542969 13.07261719 -13.14335937 12.45773437 -12.60546875 11.82421875 C-9.6626898 8.48047722 -9.6626898 8.48047722 -8 7 C-7.34 7 -6.68 7 -6 7 C-5.7525 6.401875 -5.505 5.80375 -5.25 5.1875 C-3.83629988 2.71352479 -2.34944617 1.56629745 0 0 Z ",
    fill: "#E1F5FE",
    transform: "translate(457,424)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.50000555 2.50000555 2.67756746 4.60343232 3.04296875 8.046875 C2.98248206 10.79627007 1.76663032 11.9615804 0 14 C-0.72045367 17.15118325 -0.72045367 17.15118325 -1 20 C-1.33 20 -1.66 20 -2 20 C-2.26404456 13.13484138 -1.25841946 6.74153283 0 0 Z ",
    fill: "#5DA4EB",
    transform: "translate(597,528)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.9335117 2.35406142 9.51978158 4.86384711 14 8 C13.01 8.33 12.02 8.66 11 9 C11 9.66 11 10.32 11 11 C9.68 11.33 8.36 11.66 7 12 C7 9.69 7 7.38 7 5 C6.21625 4.690625 5.4325 4.38125 4.625 4.0625 C2 3 2 3 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#58A4EB",
    transform: "translate(467,611)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.01 3.33 -0.98 3.66 -2 4 C-2.13277344 4.59296875 -2.26554687 5.1859375 -2.40234375 5.796875 C-3.25785816 8.95053595 -5.09617593 10.16578247 -7.5625 12.25 C-8.38878906 12.95640625 -9.21507812 13.6628125 -10.06640625 14.390625 C-10.70449219 14.92171875 -11.34257812 15.4528125 -12 16 C-12.66 15.67 -13.32 15.34 -14 15 C-12.98679687 14.00419922 -12.98679687 14.00419922 -11.953125 12.98828125 C-11.06109375 12.10527344 -10.1690625 11.22226562 -9.25 10.3125 C-8.36828125 9.44238281 -7.4865625 8.57226562 -6.578125 7.67578125 C-4.21194702 5.21997532 -2.08107444 2.69858952 0 0 Z ",
    fill: "#EBFCFE",
    transform: "translate(509,372)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 3.32 -4.62 4.64 -7 6 C-7 6.66 -7 7.32 -7 8 C-10.6678852 9.96189209 -13.87248551 11.39301257 -18 12 C-14.922555 8.69955174 -11.63121175 6.24183581 -7.875 3.75 C-6.82054687 3.04359375 -5.76609375 2.3371875 -4.6796875 1.609375 C-2 0 -2 0 0 0 Z ",
    fill: "#62A7E5",
    transform: "translate(355,451)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.19335938 4.53393555 C-1.73798828 5.062854 -2.28261719 5.59177246 -2.84375 6.13671875 C-3.72353516 7.00200195 -3.72353516 7.00200195 -4.62109375 7.88476562 C-5.24113281 8.47966797 -5.86117188 9.07457031 -6.5 9.6875 C-7.12003906 10.29400391 -7.74007813 10.90050781 -8.37890625 11.52539062 C-9.91264707 13.02373743 -11.45548198 14.51276493 -13 16 C-13.99 15.67 -14.98 15.34 -16 15 C-10.72 10.05 -5.44 5.1 0 0 Z ",
    fill: "#E3F9FE",
    transform: "translate(439,441)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.70342266 4.88973201 -0.36523583 5.18261792 -4 7 C-6.97329046 8.09070454 -9.97288078 9.07010063 -13 10 C-9.28249221 5.79759989 -4.68339021 3.00217321 0 0 Z ",
    fill: "#62A7E3",
    transform: "translate(335,463)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.89399469 2.34211663 -5.67155428 3.86862171 -9.125 5.25 C-10.42824219 5.78367187 -10.42824219 5.78367187 -11.7578125 6.328125 C-14 7 -14 7 -16 6 C-15.67 5.34 -15.34 4.68 -15 4 C-13.68 4 -12.36 4 -11 4 C-11 3.34 -11 2.68 -11 2 C-7.17010894 0.19769832 -4.21878192 -0.19622241 0 0 Z ",
    fill: "#62A5E3",
    transform: "translate(355,353)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.804375 0.495 0.804375 0.495 1.625 1 C4.5391061 2.22699204 6.86867708 2.14233286 10 2 C10.33 3.98 10.66 5.96 11 8 C10.01 8 9.02 8 8 8 C8 7.34 8 6.68 8 6 C7.071875 5.731875 6.14375 5.46375 5.1875 5.1875 C2.23759634 4.08851629 0.94384814 3.37581439 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#4C98DE",
    transform: "translate(212,800)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0 5 -1 7 -2 9 C-2.7136724 12.73771834 -2.7136724 12.73771834 -3 16 C-5 14 -5 14 -5.4375 10.8125 C-4.86520576 5.82536451 -3.14087292 3.84756932 0 0 Z ",
    fill: "#D2F0FD",
    transform: "translate(154,440)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.40640436 -0.3332882 13.2598894 -0.24523844 20 3 C20.66 3.66 21.32 4.32 22 5 C19.36 4.67 16.72 4.34 14 4 C14 3.34 14 2.68 14 2 C7.07 1.505 7.07 1.505 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#CCEBFE",
    transform: "translate(606,251)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.625 3.375 1.625 3.375 2 7 C1.34 7.66 0.68 8.32 0 9 C-0.46006346 11.20250992 -0.46006346 11.20250992 -0.625 13.625 C-0.69976563 14.44226563 -0.77453125 15.25953125 -0.8515625 16.1015625 C-0.90054688 16.72804688 -0.94953125 17.35453125 -1 18 C-1.66 18 -2.32 18 -3 18 C-2.51679152 11.7945858 -1.66681876 6.00054754 0 0 Z ",
    fill: "#65AAE7",
    transform: "translate(614,426)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C3.19791273 4.30616284 -2.83581485 8 -8 8 C-7.67 7.01 -7.34 6.02 -7 5 C-5.15234375 4.26953125 -5.15234375 4.26953125 -2.9375 3.8125 C-2.20402344 3.65394531 -1.47054687 3.49539063 -0.71484375 3.33203125 C0.13400391 3.16767578 0.13400391 3.16767578 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#5BA2E6",
    transform: "translate(173,424)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.584859 0.6191639 5.16776172 1.24507682 7.75 1.875 C8.47960937 2.04902344 9.20921875 2.22304688 9.9609375 2.40234375 C13.53285028 3.27908598 16.79373841 4.12686823 20 6 C13.74143617 6.38317738 9.62688867 5.75827876 4 3 C2.67723944 2.62691369 1.34767923 2.26953585 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#62A4E5",
    transform: "translate(232,489)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.04270084 3.12588014 -0.91587895 4.2506715 -1.875 5.375 C-2.40867187 6.00148438 -2.94234375 6.62796875 -3.4921875 7.2734375 C-4.61432007 8.55836651 -5.79371975 9.79371975 -7 11 C-8.32 10.67 -9.64 10.34 -11 10 C-5.555 5.05 -5.555 5.05 0 0 Z ",
    fill: "#E6F9FE",
    transform: "translate(418,461)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.44563312 2.44563312 -4.75525172 3.34131255 -7.9375 4.6875 C-8.99839844 5.14511719 -10.05929688 5.60273438 -11.15234375 6.07421875 C-14 7 -14 7 -17 6 C-12.3149827 1.90060986 -6.26086269 -0.58695588 0 0 Z ",
    fill: "#64A8E4",
    transform: "translate(217,410)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-1.33 3.34 -1.66 2.68 -2 2 C-7.12583611 1.89748328 -11.94997778 1.96409801 -17 3 C-17 2.34 -17 1.68 -17 1 C-10.55411399 -2.04714611 -6.76632168 -2.17712665 0 0 Z ",
    fill: "#D9F2FC",
    transform: "translate(517,351)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-4.21348564 6.21348564 -6.87647862 7.63258872 -13 8 C-10.83676753 5.68757908 -8.62352196 3.9843604 -5.9375 2.3125 C-5.24527344 1.87550781 -4.55304688 1.43851562 -3.83984375 0.98828125 C-2 0 -2 0 0 0 Z ",
    fill: "#63ACEA",
    transform: "translate(492,359)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C5.24727345 5.26723095 5.37334093 9.39949939 5.1875 15.375 C5.17396484 16.20644531 5.16042969 17.03789062 5.14648438 17.89453125 C5.11139059 19.92997066 5.05759228 21.96507291 5 24 C4.67 24 4.34 24 4 24 C3.96261719 22.85402344 3.92523437 21.70804687 3.88671875 20.52734375 C3.82101416 18.99736554 3.75456841 17.46741903 3.6875 15.9375 C3.66494141 15.18533203 3.64238281 14.43316406 3.61914062 13.65820312 C3.37120934 8.45164616 2.31592957 4.67532163 0 0 Z ",
    fill: "#73AEE5",
    transform: "translate(631,258)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C5.65 2.33 7.3 2.66 9 3 C9 3.66 9 4.32 9 5 C9.99 5 10.98 5 12 5 C12.33 5.99 12.66 6.98 13 8 C8.27626146 6.37621488 4.05818166 3.89006982 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#D1F0FD",
    transform: "translate(447,597)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.03644647 12.66970387 0.03644647 12.66970387 -1 18 C-1.33 18 -1.66 18 -2 18 C-2.33 15.36 -2.66 12.72 -3 10 C-2.34 10 -1.68 10 -1 10 C-1.01160156 9.36191406 -1.02320313 8.72382813 -1.03515625 8.06640625 C-1.04417969 7.24011719 -1.05320312 6.41382813 -1.0625 5.5625 C-1.07410156 4.73878906 -1.08570313 3.91507812 -1.09765625 3.06640625 C-1 1 -1 1 0 0 Z ",
    fill: "#D1F2FE",
    transform: "translate(604,478)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.6875 3.0625 3.6875 3.0625 4 5 C3.01 4.67 2.02 4.34 1 4 C1 5.32 1 6.64 1 8 C0.34 8 -0.32 8 -1 8 C-1 6.68 -1 5.36 -1 4 C-1.66 4 -2.32 4 -3 4 C-3 3.34 -3 2.68 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#589AF0",
    transform: "translate(819,248)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-0.66 2 -1.32 2 -2 2 C-2 2.66 -2 3.32 -2 4 C-8.93 3.505 -8.93 3.505 -16 3 C-16 2.67 -16 2.34 -16 2 C-15.15695312 1.93941406 -14.31390625 1.87882813 -13.4453125 1.81640625 C-12.34960938 1.73261719 -11.25390625 1.64882813 -10.125 1.5625 C-9.03445313 1.48128906 -7.94390625 1.40007813 -6.8203125 1.31640625 C-4.26398303 1.02961583 -2.50524575 0 0 0 Z ",
    fill: "#6AABE1",
    transform: "translate(564,651)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-1.55780332 2.67756882 -3.12150096 3.34159457 -4.6875 4 C-5.99267578 4.556875 -5.99267578 4.556875 -7.32421875 5.125 C-10.0572002 6.01870488 -12.14700934 6.16449676 -15 6 C-12.49876879 4.33251253 -10.22323643 3.10045639 -7.5 1.875 C-6.7265625 1.52179688 -5.953125 1.16859375 -5.15625 0.8046875 C-3 0 -3 0 0 0 Z ",
    fill: "#D2EEFD",
    transform: "translate(592,256)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 1.98 -1.32 3.96 -2 6 C-1.34 6 -0.68 6 0 6 C-0.66 7.32 -1.32 8.64 -2 10 C-3.32 7.36 -4.64 4.72 -6 2 C-2 0 -2 0 0 0 Z ",
    fill: "#53A4E8",
    transform: "translate(56,632)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C1.02 5.31 -0.96 7.62 -3 10 C-3.33 8.68 -3.66 7.36 -4 6 C-2.68 5.67 -1.36 5.34 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#5FA7E8",
    transform: "translate(504,372)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-9.22551253 5.74031891 -9.22551253 5.74031891 -15 5 C-12.30932731 3.20621821 -9.91421743 2.02686042 -6.9375 0.8125 C-5.62072266 0.26529297 -5.62072266 0.26529297 -4.27734375 -0.29296875 C-2 -1 -2 -1 0 0 Z ",
    fill: "#CAECFD",
    transform: "translate(548,275)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.75 4.82421875 C-2.4925 5.43910156 -3.235 6.05398438 -4 6.6875 C-4.7425 7.31011719 -5.485 7.93273437 -6.25 8.57421875 C-6.8275 9.04472656 -7.405 9.51523437 -8 10 C-8.66 9.67 -9.32 9.34 -10 9 C-6.7 6.03 -3.4 3.06 0 0 Z ",
    fill: "#DDF4FE",
    transform: "translate(389,488)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.31 3.32 -4.62 4.64 -7 6 C-7.99 5.34 -8.98 4.68 -10 4 C-8.71086513 3.32845067 -7.41859796 2.66291141 -6.125 2 C-5.40570313 1.62875 -4.68640625 1.2575 -3.9453125 0.875 C-2 0 -2 0 0 0 Z ",
    fill: "#67AAE8",
    transform: "translate(504,353)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.43429001 0.67354499 -2.87257057 1.33859701 -4.3125 2 C-5.51326172 2.556875 -5.51326172 2.556875 -6.73828125 3.125 C-9 4 -9 4 -12 4 C-11.67 3.01 -11.34 2.02 -11 1 C-6.90275533 -0.54613006 -4.18142349 -1.29227216 0 0 Z ",
    fill: "#5DA2E7",
    transform: "translate(476,304)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-2.31 3 -4.62 3 -7 3 C-7 3.66 -7 4.32 -7 5 C-8.65 5 -10.3 5 -12 5 C-8.51164396 2.04831412 -4.66588377 0 0 0 Z ",
    fill: "#D2EFFD",
    transform: "translate(476,304)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C0.535 3.97 0.535 3.97 -3 7 C-2 3 -2 3 0 0 Z ",
    fill: "#71ABEA",
    transform: "translate(485,393)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-6.625 3 -6.625 3 -10 3 C-10 2.01 -10 1.02 -10 0 C-6.33694766 -0.74926071 -3.57644848 -1.2380014 0 0 Z ",
    fill: "#5CA4E2",
    transform: "translate(457,312)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 1.32 -1.32 2.64 -2 4 C-3.32 4 -4.64 4 -6 4 C-6 3.01 -6 2.02 -6 1 C-4 0 -4 0 0 0 Z ",
    fill: "#3EA5F1",
    transform: "translate(760,706)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.83430453 4.2542015 -2.68607774 5.5206753 -7 6 C-2.25 1.125 -2.25 1.125 0 0 Z ",
    fill: "#DCF4FE",
    transform: "translate(162,434)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C-0.465 4.97 -0.465 4.97 -4 8 C-3.07377893 4.29511572 -2.32789515 2.83395931 0 0 Z ",
    fill: "#5EA2E9",
    transform: "translate(444,432)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C0.535 3.97 0.535 3.97 -3 7 C-3 5.68 -3 4.36 -3 3 C-2.01 3 -1.02 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#5BA5E6",
    transform: "translate(468,409)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-4.455 3.495 -4.455 3.495 -9 4 C-6.43425105 1.43425105 -3.68548192 0 0 0 Z ",
    fill: "#E0F6FE",
    transform: "translate(236,403)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 2.65 2.34 4.3 2 6 C0.68 5.34 -0.64 4.68 -2 4 C-2 3.01 -2 2.02 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#3B8EEE",
    transform: "translate(197,789)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C4.67 2.98 4.34 4.96 4 7 C2.10786631 4.61426621 0.97608217 2.92824652 0 0 Z ",
    fill: "#499FE7",
    transform: "translate(39,612)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 1.32 2.66 2.64 3 4 C3.66 4 4.32 4 5 4 C4.67 5.98 4.34 7.96 4 10 C1.81024227 6.71536341 1.00193437 3.79303725 0 0 Z ",
    fill: "#4F9DE2",
    transform: "translate(19,561)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.93254772 4.0245738 -2.63158688 5.42105792 -5 7 C-5.99 6.67 -6.98 6.34 -8 6 C-5.36 4.02 -2.72 2.04 0 0 Z ",
    fill: "#69A8E2",
    transform: "translate(384,430)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C1.03 3.475 1.03 3.475 -2 6 C-2.33 5.01 -2.66 4.02 -3 3 C-2.34 3 -1.68 3 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#65A4E9",
    transform: "translate(460,417)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-3.67568464 3.91892116 -5.16380575 3.95904856 -9 3 C-6.03 2.01 -3.06 1.02 0 0 Z ",
    fill: "#CFEFFC",
    transform: "translate(571,264)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 2.31 1.66 4.62 2 7 C1.01 7 0.02 7 -1 7 C-1 7.99 -1 8.98 -1 10 C-1.66 9.67 -2.32 9.34 -3 9 C-2.01 6.03 -1.02 3.06 0 0 Z ",
    fill: "#62A3E6",
    transform: "translate(582,624)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.01 3.33 -0.98 3.66 -2 4 C-2 4.99 -2 5.98 -2 7 C-3.32 7.33 -4.64 7.66 -6 8 C-4.02 5.36 -2.04 2.72 0 0 Z ",
    fill: "#DEF8FE",
    transform: "translate(509,372)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.875 2.9375 0.875 2.9375 -1 5 C-4.1875 5.75 -4.1875 5.75 -7 6 C-4.74259377 3.66475218 -2.7194239 1.81294927 0 0 Z ",
    fill: "#66AAE0",
    transform: "translate(477,367)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C3.67 1.32 3.34 2.64 3 4 C2.01 3.67 1.02 3.34 0 3 C-0.33 3.66 -0.66 4.32 -1 5 C-1.66 4.67 -2.32 4.34 -3 4 C-1.75 2 -1.75 2 0 0 Z ",
    fill: "#46A1E6",
    transform: "translate(76,184)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C3.01 2 2.02 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#299CC4",
    transform: "translate(721,111)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.02 1.99 0.02 1.99 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#3773D5",
    transform: "translate(146,103)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#3674D9",
    transform: "translate(151,760)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#489AE3",
    transform: "translate(713,755)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#3FA9C5",
    transform: "translate(145,755)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#29B3DF",
    transform: "translate(723,746)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#297AD9",
    transform: "translate(135,746)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#3570B6",
    transform: "translate(748,721)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#3167E4",
    transform: "translate(111,721)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#336FE7",
    transform: "translate(747,136)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#2ABEDB",
    transform: "translate(136,112)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#4C9EE4",
    transform: "translate(712,103)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#0214B4",
    transform: "translate(186,786)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#26A3B9",
    transform: "translate(113,724)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#0A14A8",
    transform: "translate(672,787)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#25E7FF",
    transform: "translate(679,782)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#0715B1",
    transform: "translate(175,779)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#01109A",
    transform: "translate(691,773)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#001AA3",
    transform: "translate(167,773)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3675C3",
    transform: "translate(700,766)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#1351C9",
    transform: "translate(158,766)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#44DFE8",
    transform: "translate(706,761)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000EDB",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0016D3",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0018E0",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001BE2",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3662F3",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#43E5EC",
    transform: "translate(706,98)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#59E1F1",
    transform: "translate(152,98)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#38D9F4",
    transform: "translate(700,93)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3CE3FA",
    transform: "translate(158,93)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3163E2",
    transform: "translate(695,89)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3663E6",
    transform: "translate(163,89)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#0022B2",
    transform: "translate(691,86)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#0710AF",
    transform: "translate(167,86)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#00124C",
    transform: "translate(175,80)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#0013D2",
    transform: "translate(679,77)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#0712A8",
    transform: "translate(672,72)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000DBD",
    transform: "translate(0,0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000CDE",
    transform: "translate(0,0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0111B9",
    transform: "translate(0,0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000EC1",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0B12B8",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000D7C",
    transform: "translate(0,0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001176",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0D1695",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000CBB",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000583",
    transform: "translate(0,0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#030FB4",
    transform: "translate(0,0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000E51",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00081C",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3179C5",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3778C4",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000C68",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00349B",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D6ECA",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#67BAFF",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000740",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001878",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001BCD",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D6ECC",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#337FE0",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00319F",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41E4FA",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000DAD",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#040DB2",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1D7AE1",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1770D4",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#177CDA",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1677D1",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0C82C9",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1580C4",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCFFF",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CDFF",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0FF9FA",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#26E5FF",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1EE1FF",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00F7FE",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7FB7FF",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#22EAFF",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000ED0",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0025C3",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0017B1",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001FAD",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0011CE",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013D3",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0020C4",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001DCE",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013CB",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012D0",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012AC",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0021B6",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012CB",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001ECC",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56B4FF",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70B6FF",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2EDBFF",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0017C7",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CFFF",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6AABFF",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001CCE",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012C5",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0017B0",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0617B5",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0018DB",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0011CB",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0032A8",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57D3FF",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#24F2FF",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#22E7FF",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2CF1FF",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43DDFF",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0BEDFF",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3DF0FF",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0FFFFF",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0EEBFF",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00329D",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00328C",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002B9A",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71BCFF",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#32E2EB",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47E8FF",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#29D7EE",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FEDFF",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#31DFF6",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2FE7FB",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#36E6EF",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#34DCFE",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FE0F5",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0018BC",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0311A9",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001BC1",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001ACB",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61D3FF",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50C9FF",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#19F3FF",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0BECFF",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#29E3FF",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1DDAFF",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3DDAF9",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3EDFF2",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45E3FF",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38DAF1",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001AB9",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001BB3",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#35E0FF",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#28DFFF",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#73BAFF",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4BCDFF",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0210B4",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000BB1",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44F0FA",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41D7E7",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49EFFB",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40D9E5",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C6E7",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#69CDFB",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41DFF3",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#28C6DC",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74C9FF",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71BCFF",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#003291",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00348F",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8BB8FF",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7EB6FF",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0022C8",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0009D8",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3ADBFF",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0517C3",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0016AF",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0209C1",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0C1AB5",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0917B9",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43E4F2",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3EE4F3",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000FB1",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013B3",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#140CA3",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000FAF",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#031DB4",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000DA7",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002A72",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002572",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0010C7",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0316BA",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0716C3",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0717B3",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0017B1",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000B1C",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0017A3",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0113B8",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0011AC",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0312A5",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00176A",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#012465",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012AD",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0010AE",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0716B9",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0018BB",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0317BD",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0712B9",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45E1F5",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FD9EE",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0015BE",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45E2F1",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0C0AAE",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0B18C3",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013B6",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0411BC",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0014E0",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000CD5",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#82C5FF",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9AB8FF",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00298B",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#003192",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#75C2FF",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70C0FF",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FE6FF",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3AE7F5",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60D1F2",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62D0EB",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4FE3F0",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4ADAF5",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4AE6EA",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4ED8F5",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0317A9",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#011FB9",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC2FF",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FCAFF",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#37EDFF",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3AECFF",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001EB8",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001EBC",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43E6FF",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3EE1FF",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48E9FF",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#35D5FD",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#25E1FF",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1CDBFF",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#23EBFF",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1DEDFF",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62BCFF",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C4FF",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001FCC",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0018C3",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000489",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001AB3",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000EA7",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FDCF4",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4BDCFF",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#32E2EB",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FDEFD",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#32E8F6",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#37E6EB",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#34E7F6",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2FDEE2",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2FE4ED",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6DD0DA",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001624",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00369B",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002883",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0011CF",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#18F1FF",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1FE1FF",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#07FFFF",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0DF8FF",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#15F3FF",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#21E4FF",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3BE7FF",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#52CFFB",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#28E9FF",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#26EEFF",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002DAB",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40D4FF",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0018DA",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013BB",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#00309E",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0020AE",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38E5FF",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001ED3",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44D5F6",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4DC3FF",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#35ECFF",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2CE8FF",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3ED6F5",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48E0FE",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#33E0FF",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3FEFFF",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002D8E",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002FA6",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0021DF",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012CF",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0011B9",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0014A2",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013D5",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013C5",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001EBD",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0017A9",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000FD5",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000FCB",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0038BD",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0034B9",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#03E2FF",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#13EEFF",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#09FBF5",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0CFFF7",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#34E0EA",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0C82C5",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#37DEEA",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#267DD8",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1A84D4",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2479D5",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1F7CDC",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001A6D",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0019BC",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000052",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#003391",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1F77DE",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3177FA",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#157FF3",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0012B5",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002C83",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000540",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#117ACB",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#85C5FF",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1F7CD1",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001E69",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#167BD9",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2486D9",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0027B8",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001EBD",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002397",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#002A9D",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#1774E6",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0014DA",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000759",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0318B9",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0918B2",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0023BE",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#0013BA",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#001CC5",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.ac7740358c85206a03970f0b0594576c.svg";
export { ForwardRef as ReactComponent };